import { Spacing } from 'zens-storybook'
import React, { useMemo } from 'react'
import { StyleSheet, View } from 'react-native'
import { NormalizedCompanyColorScheme, programColorsForDay, ScheduleVisualProgram, ScheduleWeekday, ScheduleWeekdays } from 'zens-store'

import { setDay } from 'date-fns'

import ScheduleSelection from './selection'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginVertical: -Spacing.XXS / 2,
  },
  row: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    height: 10,
    marginVertical: Spacing.XXS / 2,
    marginRight: -3,
  },
})

interface Props {
  program?: Record<ScheduleWeekday, ScheduleVisualProgram>
  colorScheme: NormalizedCompanyColorScheme
}
const ScheduleProgram = (props: Props) => {
  const { program, colorScheme } = props

  const dayColors = useMemo(
    () =>
      new Array(7).fill(null).map((_, index) => {
        const date = setDay(new Date(), index, { weekStartsOn: 1 })
        const scheduleDay = program?.[ScheduleWeekdays[index]]
        return programColorsForDay(date, scheduleDay, undefined, colorScheme)
      }),
    [colorScheme, program],
  )

  return (
    <View style={styles.container}>
      {dayColors.map((colors, index) => {
        return (
          <View key={`day-${index}`} style={[styles.row, { zIndex: (ScheduleWeekdays.length - index) * 100 }]}>
            <ScheduleSelection colors={colors} />
          </View>
        )
      })}
    </View>
  )
}

export default ScheduleProgram
